import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

const links = [
  { label: "The Science", href: "#science" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Pricing", href: "#pricing" },
];

export const Nav = ({ onPreorder }) => (
  <header
    data-testid="main-nav"
    className="sticky top-0 z-40 backdrop-blur-xl bg-navy/80 border-b border-white/10"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-4">
      <a href="#top" data-testid="nav-logo" className="flex items-center gap-2 shrink-0">
        <img
          src="/images/master-blaster-logo.png"
          alt="The Master Blaster logo"
          className="h-11 w-auto rounded-sm"
        />
      </a>
      <nav className="hidden md:flex items-center gap-8">
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            className="font-jbmono text-xs uppercase tracking-[0.2em] text-cream/60 hover:text-gold transition-colors duration-200"
          >
            {l.label}
          </a>
        ))}
      </nav>
      <div className="flex items-center gap-3">
        <Link
          to="/admin"
          data-testid="nav-owner-login"
          className="hidden sm:flex items-center gap-1.5 font-jbmono text-xs uppercase tracking-widest text-cream/50 hover:text-cream transition-colors duration-200"
        >
          <Lock className="w-3.5 h-3.5" />
          Owner
        </Link>
        <button
          onClick={onPreorder}
          data-testid="nav-preorder-button"
          className="bg-crimson hover:bg-crimsondark text-white font-display font-bold uppercase tracking-wide px-5 py-2 rounded-sm text-sm transition-colors duration-200"
        >
          Pre-Order
        </button>
      </div>
    </div>
  </header>
);
